var map = {
	"./components/dashboard/dashboard.module": [
		"./src/app/content/pages/components/dashboard/dashboard.module.ts",
		"components-dashboard-dashboard-module"
	],
	"app/content/pages/pages.module": [
		"./src/app/content/pages/pages.module.ts",
		"app-content-pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;